import { AuroraIcon } from './AuroraIcon';

/**
 * author: Jeff Anders
 * id 3ED13D0F-1EC7-4EBF-99F4-B686272A00AC
 * name aurora
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/aurora.svg
 * tags
 * - Science 
 * - Weather 
 */
export const AuroraBorealisIcon = AuroraIcon;
export default AuroraBorealisIcon